import React, { useCallback } from 'react';
import cx from 'classnames';
import { Input } from 'reactstrap';

import styles from './RubricWeights.module.scss';

function RubricQuestionSetWeightRow({
  questionSet,
  className = 'palette-tiers-1 muted-bg',
  isStandardView,
  draftWeight,
  standardWeight,
  committedWeight,
  onChange,
}) {
  const qs = questionSet;
  const questionSetGuid = qs.guid;

  const handleOnChangeValue = useCallback(
    (ev) => onChange(questionSetGuid, ev.target.value),
    [onChange, questionSetGuid]
  );

  const hasOverride =
    draftWeight !== undefined &&
    draftWeight !== null &&
    String(draftWeight) !== '';
  const isChanged = String(draftWeight ?? '') !== String(committedWeight ?? '');

  return (
    <div
      className={cx(
        styles['question-set-weight-row'],
        styles['weight-row'],
        className
      )}
    >
      <div className={styles['weight-row-name']}>{qs.name}</div>
      <div className={styles['weight-row-value']}>
        <Input
          className={cx(styles['weight-input'], {
            [styles['weight-input--changed']]: isChanged,
            [styles['weight-input--overridden']]:
              !isStandardView && !isChanged && hasOverride,
          })}
          placeholder={isStandardView ? undefined : standardWeight}
          value={draftWeight}
          onChange={handleOnChangeValue}
        />
      </div>
    </div>
  );
}

export default RubricQuestionSetWeightRow;
